import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getProductLookup } from '../services/catalog.service';

export interface ProductInfo {
	name: string;
	periodicity?: 'monthly' | 'annual';
}

/**
 * A `product_version_id → { name, periodicity }` map for every product, sourced
 * from the sales-transaction-engine catalog (`/pricing/product-lookup`). Lets surfaces that
 * only have a `product_version_id` (the cart/order) label any item without the
 * legacy productList. Names aren't user-specific, so the cache isn't user-scoped.
 */
export const useProductLookup = () => {
	const { data } = useQuery({
		queryKey: ['product-lookup'],
		queryFn: getProductLookup,
		staleTime: 30 * 60 * 1000,
	});

	return useMemo(() => {
		const byVersionId = new Map<number, ProductInfo>();
		for (const item of data ?? []) {
			byVersionId.set(item.product_version_id, {
				name: item.name,
				periodicity: item.periodicity,
			});
		}
		return byVersionId;
	}, [data]);
};
